import * as React from "react";
import { useHistory } from "react-router-dom";
import {
  Body1,
  Card,
  CardHeader,
  CardFooter,
  Caption1,
  Text,
  Title1,
  List,
  ListItem,
  Link,
  Image,
  makeStyles,
  tokens,
  mergeClasses,
} from "@fluentui/react-components";

import SignInButton from "../components/SignInButton";
import { PATHS } from "../components/routes/paths";
import { usePageStyles } from "../styles/styles";
import { UserContext } from "../store/user-contex-api";

import { FUNC_NAMESPACE } from "../../functions/functions-extra-metadata";
import { CUSTOM_FUNCTION_NAMES } from "../../functions/functions-metadata";
import { LOGO_SRC } from "../../helpers/utils";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  card: {
    maxWidth: "100%",
    height: "fit-content",
  },
  caption: {
    color: tokens.colorNeutralForeground3,
  },
  cardFooter: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },

  img: {
    boxShadow: tokens.shadow64,
  },
});

export default function HomePage() {
  const { isAuthenticated, name } = React.useContext(UserContext);
  const pageStyles = usePageStyles();
  const styles = useStyles();
  const history = useHistory();

  return (
    <div className={mergeClasses(pageStyles.container, styles.container)}>
      {isAuthenticated && <Title1>Welcome, {name.split(" ")[0]}</Title1>}
      <Card className={styles.card}>
        <CardHeader
          image={
            <Image className={styles.img} src={LOGO_SRC} alt="logo" shape="rounded" height={75} width={75} bordered />
          }
          header={
            <Body1>
              <Text weight="semibold" size={800} font="monospace">
                GEOLYSIS-EXCEL
              </Text>
            </Body1>
          }
          description={
            <Caption1 className={styles.caption}>A Microsoft Excel Addin for Geotechnical analysis and design</Caption1>
          }
        />

        <CardFooter className={styles.cardFooter}>
          {!isAuthenticated && <SignInButton appearance="primary" />}
        </CardFooter>
      </Card>

      <Text size={500} weight="semibold" block>
        Available custom functions
      </Text>

      <List className="flex flex-col gap-[0.75rem]">
        {CUSTOM_FUNCTION_NAMES.map((funcName) => (
          <ListItem as="li" key={funcName}>
            <Link
              onClick={() => history.push(`${PATHS.DOCS_PAGE}/${funcName}`)}
            >{`${FUNC_NAMESPACE}.${funcName}`}</Link>
          </ListItem>
        ))}
      </List>
    </div>
  );
}
